module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot/spot-262-0f48f36de108950e729f7bc18f9004ea.jpg";